<template>
    <ClToast
        v-if="showSnackbar"
        v-model="showSnackbar"
        :type="snackbar.type"
        :text="snackbar.message"
        :timeout="snackbar.duration"
        :height="snackbar.height"
        :width="snackbar.width"
        :top="snackbar.top"
        :right="snackbar.right"
        :bottom="snackbar.bottom"
        :left="snackbar.left"
    >
        <ClButton
            slot="action"
            v-if="snackbar.actionText"
            color="white"
            text
            @click="actionHandler()"
        >
            {{ snackbar.actionText }}
        </ClButton>
    </ClToast>
</template>

<script>
// Vuex
import { mapGetters, mapState } from 'vuex';

export default {
    name: 'GlobalSnackbar',
    computed: {
        ...mapGetters( {
            hasSnackbar: 'hasSnackbar',
        } ),
        ...mapState( {
            snackbar: ( state ) => state.snackbar,
        } ),
        showSnackbar: {
            get() {
                return this.hasSnackbar;
            },
            set() {
                this.dismissSnackbar();
            },
        },
    },
    methods: {
        dismissSnackbar() {
            this.$store.dispatch( 'clearSnackbar' );
        },
        actionHandler() {
            if ( this.snackbar.onAction ) {
                this.snackbar.onAction();
            }
            this.dismissSnackbar();
        },
    },
};
</script>
